// src\App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuthGuard from "./AuthGuard";// 閲覧制限
import Header from "./components/Header";
import Footer from "./components/Footer";
import Breadcrumb from "./components/Breadcrumb";
import Company from "./pages/Company";
import CompanyOverview from "./pages/CompanyOverview";
import Philosophy from "./pages/Philosophy";
import Organization from "./pages/Organization";
import BusinessContent from "./pages/BusinessContent";
import Minpaku from "./pages/Minpaku";
import MinpakuDetail from "./pages/MinpakuDetail";
import Realestate from "./pages/RealEstate";
import RealEstateDetail from "./pages/RealEstateDetail";
import News from "./pages/News";
import Contact from "./pages/Contact";
import Top from "./pages/Top";
import NewsDetail from "./pages/NewsDetail"; // お知らせ詳細画面
import AdminApp from "./pages/admin/AdminApp"; // 管理画面
import NotFound from "./pages/NotFound"; // 404ページをインポート
import "./App.css";
import { HelmetProvider } from "react-helmet-async"; // SEO対策

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Header />
            <main className="flex-1 w-full">
              <Routes>
                {/* トップページ */}
                <Route path="/" element={<Top />} />
                {/* 会社情報のページ（パンくずリストを含む） */}
                <Route path="/company" element={
                  <>
                    <Breadcrumb />
                    <Company />
                  </>
                } />
                <Route path="/company/companyOverview" element={
                  <>
                    <Breadcrumb />
                    <CompanyOverview />
                  </>
                } />
                <Route path="/company/philosophy" element={
                  <>
                    <Breadcrumb />
                    <Philosophy />
                  </>
                } />
                <Route path="/company/organization" element={
                  <>
                    <Breadcrumb />
                    <Organization />
                  </>
                } />

                {/* {お知らせ詳細} */}
                <Route path="/news/:id" element={<NewsDetail />} />
                
                <Route path="/businessContent" element={
                  <>
                    <Breadcrumb />
                    <BusinessContent />
                  </>
                } />
                <Route path="/businessContent/minpaku" element={
                  <>
                    <Breadcrumb />
                    <Minpaku />
                  </>
                } />
                <Route path="/businessContent/minpaku/:id" element={<MinpakuDetail />} />
                <Route path="/businessContent/real-estate" element={
                  <>
                    <Breadcrumb />
                    <Realestate />
                  </>
                } />
                <Route path="/businessContent/real-estate/:id" element={<RealEstateDetail />} />
                <Route path="/news" element={
                  <>
                    <Breadcrumb />
                    <News />
                  </>
                } />
                <Route path="/contact" element={
                  <>
                    <Breadcrumb />
                    <Contact />
                  </>
                } />
                <Route path="/*" element={<NotFound />} />
                {/* 管理画面 */}
                
                <Route path="/admin/*" element={
                  <AuthGuard>
                  <AdminApp />
                  </AuthGuard>
                } />
                
                </Routes>
              </main>
            <Footer />
          </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
